export enum LegendItemType {
  Default,
  Couch,
  Wheelchair,
  ScreenElement,
  SeatGroup,
}
